import Flickity from 'flickity'
import 'flickity-as-nav-for'

const SkewHeroSlider = (() => {
  const init = () => {
    // sliders
    const contentSliderContainer = document.querySelector('.js-skew-content-slider')
    const imageSliderContainer = document.querySelector('.js-skew-image-slider')
    // progress
    const current = document.querySelector('.js-skew-current')
    const total = document.querySelector('.js-skew-total')
    const track = document.querySelector('.js-skew-track')
    // arrows
    const nextArrow = document.querySelector('.js-skew-next')

    if (contentSliderContainer) {
      const contentSlider = new Flickity(contentSliderContainer, {
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        wrapAround: true,
      })
    
      let imageSlider = null
      if (imageSliderContainer) {
        imageSlider = new Flickity(imageSliderContainer, {
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
          wrapAround: true,
          asNavFor: contentSliderContainer,
          setGallerySize: false
        })
      }

      if (total) {
        const slidesLength = contentSlider.slides.length
        total.innerHTML = slidesLength < 10 ? '0' + slidesLength : slidesLength
      }

      let trackWidth = 100 / contentSlider.slides.length
      if (track) {
        track.setAttribute('style', `width:${trackWidth}%;`)
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', () => {
          contentSlider.next()
        })
      }

      let timeoutId
      contentSlider.on('change', i => {
        if (current) {
          if (timeoutId) {
            clearTimeout(timeoutId)
          }

          current.classList.add('on-change')
          timeoutId = setTimeout(() => {
            current.innerHTML = (i+1) < 10 ? '0' + (i+1) : (i+1)
            current.classList.remove('on-change')
          }, 300)
        }

        if (track) {
          track.setAttribute('style', `width:${trackWidth}%;transform:scaleX(${contentSlider.selectedIndex + 1});`)
        }
      })
    }
  }

  return {
    init
  }
  
})()

export default SkewHeroSlider


// WEBPACK FOOTER //
// app/javascript/scripts/components/SkewHeroSlider.js